// @flow
import React from 'react';
import MarkdownRender from 'components/common/MarkdownRender';
import './EventContent.scss';

type Props = {
  body: string,
  theme: string,
  thumbnail: ?string,
  onSetToc: (toc: any) => void,
  onActivateHeading: (headingId: string) => void,
};

const EventContent = ({ body, onSetToc, onActivateHeading, thumbnail, theme }: Props) => (
  <div className="EventContent">
    {/* <div className="event-info">
      {thumbnail && (
        <div className="event-thumbnail">
          <img src={thumbnail} alt="event-thumbnail" />
        </div>
      )}
    </div> */}
    <div className="contents">
      <MarkdownRender
        body={body}
        onSetToc={onSetToc}
        onActivateHeading={onActivateHeading}
        theme={theme || 'github'}
      />
    </div>
  </div>
);

EventContent.Placeholder = () => (
  <div className="EventContent placeholder">
    <div className="event-thumbnail">
      <div className="fake-img" />
    </div>
    <div className="contents">
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '75%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
    </div>
  </div>
);

export default EventContent;



// WEBPACK FOOTER //
// ./src/components/event/EventContent/EventContent.js